<template>
  <AppDialog
    :is-open="isDialogOpened"
    :cancel-disabled="postGroupLoading"
    :ok-loading="postGroupLoading"
    @cancel="closeDialog"
    @ok="preparePostGroup"
  >
    <template #title>{{ $t('project.members.dialogs.MembersAddGroupDialog.addGroup') }}</template>

    <template #body>
      <form @submit.prevent="preparePostGroup">
        <AppTextField
          v-model="groupName"
          :counter="100"
          :error-messages="groupNameErrors"
          :label="$t('project.members.dialogs.MembersAddGroupDialog.lblGroupName')"
          autofocus
          class="required mt-4"
        />
      </form>
    </template>
  </AppDialog>
</template>

<script>
import { useVuelidate } from '@vuelidate/core'
import { maxLength, required } from '@vuelidate/validators'
import { mapActions, mapState } from 'vuex'

import AppTextField from '@/common/AppTextField.vue'
import AppDialog from '@/common/dialogs/AppDialog.vue'
import { formFieldErrors } from '@/common/utils/form'
import { toast } from '@/common/utils/toast'
import { dialogMixin } from '@/mixins/dialogMixin'

export default {
  name: 'MembersAddGroupDialog',
  components: { AppTextField, AppDialog },
  setup: () => ({ v$: useVuelidate() }),
  mixins: [dialogMixin],
  validations: {
    groupName: {
      required,
      maxLength: maxLength(100),
    },
  },
  data () {
    return {
      groupName: '',
    }
  },
  computed: {
    ...mapState('groups', ['postGroupLoading']),
    groupNameErrors () {
      return formFieldErrors(
          this.v$.groupName,
          [
            ['maxLength', this.$t('project.members.dialogs.MembersAddGroupDialog.maxLength')],
            ['required', this.$t('project.members.dialogs.MembersAddGroupDialog.required')],
          ],
      )
    },
  },
  methods: {
    ...mapActions('groups', ['POST_GROUP']),
    async preparePostGroup () {
      this.v$.$touch()
      if (!this.v$.$invalid) {
        try {
          await this.POST_GROUP({
            mnemo: this.$route.params.mnemo,
            groupName: this.groupName,
          })
        } catch (e) {
          console.error(e)
          toast.error(this.$t('common.msgFailErrorOccurred'))
          // Unhandled and shouldn't happen... Throw it to either handle it later or let Sentry send it back
          throw e
        }
        this.closeDialog()
      }
    },
  },
}
</script>
